<div *ngIf="selectedCancerTypeComorbidityGraph" id="comorbidities-plot">
  <plotly-plot
    [data]="selectedCancerTypeComorbidityGraph.data"
    [layout]="selectedCancerTypeComorbidityGraph.layout"
    (plotly_click)="select_comorbidity_seeds($event)"
  ></plotly-plot>
</div>
